import React, { useEffect, useState } from "react";
import { getAllTenders, deleteTender } from "../../services/tenderService";
import { Link, useNavigate } from "react-router-dom";

export default function TenderList() {
  const [tenders, setTenders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [publishDate, setPublishDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [tendersPerPage] = useState(8);
  const [selectedTender, setSelectedTender] = useState(null);
  const navigate = useNavigate();

  // ✅ Load all tenders
  const loadTenders = async () => {
    try {
      const data = await getAllTenders();
      setTenders(data);
    } catch (err) {
      console.error("Error loading tenders:", err);
    }
  };

  useEffect(() => {
    loadTenders();
  }, []);

  // ✅ Delete tender
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this tender?")) {
      try {
        await deleteTender(id);
        alert("Tender deleted successfully!");
        loadTenders();
      } catch (err) {
        console.error(err);
        alert("Error deleting tender!");
      }
    }
  };

  // ✅ Filter tenders
  const filteredTenders = tenders.filter((t) => {
    const matchesTitle = t.title
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesDate = publishDate
      ? new Date(t.publishDate).toISOString().split("T")[0] === publishDate
      : true;
    return matchesTitle && matchesDate;
  });

  // ✅ Pagination
  const indexOfLastTender = currentPage * tendersPerPage;
  const indexOfFirstTender = indexOfLastTender - tendersPerPage;
  const currentTenders = filteredTenders.slice(
    indexOfFirstTender,
    indexOfLastTender
  );
  const totalPages = Math.ceil(filteredTenders.length / tendersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // ✅ Limit title length
  const truncateTitle = (text, limit = 30) => {
    return text?.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // ✅ Open modal
  const handleView = (tender) => {
    setSelectedTender(tender);
    const modal = new window.bootstrap.Modal(
      document.getElementById("tenderModal")
    );
    modal.show();
  };

  return (
    <div className="container mt-4">
      {/* 🔍 Header and Actions */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold">Notice Board List</h3>
        <Link to="/admin/tender/create" className="btn btn-primary">
          + Add Notice Board
        </Link>
      </div>

      {/* 🔎 Search and Filter */}
      <div className="row mb-3">
        <div className="col-md-6">
          <input
            type="text"
            placeholder="Search by title..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-4">
          <input
            type="date"
            className="form-control"
            value={publishDate}
            onChange={(e) => {
              setPublishDate(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-2">
          <button
            className="btn btn-secondary w-100"
            onClick={() => {
              setSearchTerm("");
              setPublishDate("");
            }}
          >
            Reset
          </button>
        </div>
      </div>

      {/* 📋 Table */}
      {currentTenders.length === 0 ? (
        <p className="text-center">No tenders found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark text-center">
              <tr>
               
                <th>Notice No.</th>
                <th>Title</th>
                <th>Publish Date</th>
                
                <th>File</th>
                <th>Created By</th>
               
                <th style={{ width: "280px" }}>Action</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {currentTenders.map((tender) => (
                <tr key={tender.id}>
                
                  <td>{tender.tenderNumber}</td>
                  <td title={tender.title}>{truncateTitle(tender.title)}</td>
                  <td>
                    {new Date(tender.publishDate).toLocaleDateString("en-IN")}
                  </td>
                  
                  <td>
                    {tender.fileUrl ? (
                      <a
                        href={`http://localhost:5213${tender.fileUrl}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View File
                      </a>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td>{tender.createdBy}</td>
                 
                  <td>
                    <button
                      className="btn btn-sm btn-success me-2"
                      onClick={() => handleView(tender)}
                    >
                      👁 View
                    </button>
                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() =>
                        navigate(`/admin/tender/edit/${tender.id}`)
                      }
                    >
                      ✏️ Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(tender.id)}
                    >
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 📄 Pagination */}
      {totalPages > 1 && (
        <nav>
          <ul className="pagination justify-content-center mt-3">
            {[...Array(totalPages).keys()].map((num) => (
              <li
                key={num}
                className={`page-item ${
                  currentPage === num + 1 ? "active" : ""
                }`}
              >
                <button
                  onClick={() => paginate(num + 1)}
                  className="page-link"
                >
                  {num + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}

      {/* 🪟 Modal */}
      <div
        className="modal fade"
        id="tenderModal"
        tabIndex="-1"
        aria-labelledby="tenderModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-dark text-white">
              <h5 className="modal-title" id="tenderModalLabel">
                Tender Details
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {selectedTender && (
              <div className="modal-body">
                <div className="row mb-2">
                  <div className="col-md-6">
                    <strong>Title:</strong> {selectedTender.title}
                  </div>
                  <div className="col-md-6">
                    <strong>Tender No:</strong> {selectedTender.tenderNumber}
                  </div>
                </div>
                <div className="mb-2">
                  <strong>Description:</strong>
                  <p>{selectedTender.description || "No description"}</p>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <strong>Publish Date:</strong>{" "}
                    {new Date(selectedTender.publishDate).toLocaleDateString(
                      "en-IN"
                    )}
                  </div>
                  <div className="col-md-6">
                    <strong>Closing Date:</strong>{" "}
                    {new Date(selectedTender.closingDate).toLocaleDateString(
                      "en-IN"
                    )}
                  </div>
                </div>
                <div className="mb-2">
                  <strong>File:</strong>{" "}
                  {selectedTender.fileUrl ? (
                    <a
                      href={`http://localhost:5213${selectedTender.fileUrl}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View File
                    </a>
                  ) : (
                    "No file uploaded"
                  )}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <strong>Created By:</strong> {selectedTender.createdBy}
                  </div>
                  <div className="col-md-6">
                    <strong>Status:</strong>{" "}
                    {selectedTender.isActive ? "Active ✅" : "Inactive ❌"}
                  </div>
                </div>
              </div>
            )}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
